export enum ItemType {
    File,
    Folder,
    Media,
    OneNote,
    Unknown,
    Error,
    App,
    Subsite,
    /** A shortcut link pointing to some target destination or Url */
    Shortcut
}

export default ItemType;